import React, { useState } from 'react';
import { Box, ButtonBase, Dialog, IconButton, makeStyles, Typography, InputBase } from '@material-ui/core';
import { CloseIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-root': {
      padding: '0',
      margin: '0',
      boxShadow: 'unset',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '43.75rem',
    borderRadius: '0.625rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    overflow: 'auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '2.375rem 1.875rem 1.563rem 1.563rem',
  },
  headerTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
    margin: '-12px -12px 0 0',
  },
  label: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#7d86a9',
    marginBottom: '0.625rem',
  },
  main: {
    padding: '0 1.563rem',
    overflow: 'auto',
  },
  InputBase: {
    height: '3.5rem',
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    width: '100%',
    paddingLeft: '1.25rem',
    marginBottom: '1.875rem',
    '& .MuiInputBase-input': {
      fontSize: '1rem',
      color: '#2e4469',
      fontFamily: 'NotoSans-Medium',
    },
  },
  cancelBtn: {
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    border: 'solid 1.5px #538fff',
    color: '#538fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    background: '#f5faff',
  },
  configBtn: {
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    background: '#538fff',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
  },
}));

export default function RoleAdd({ closePop, open, title, allData, confirmClick, confirmText }) {
  const classes = useStyles();
  // input
  const [inputValues, setInputValues] = useState({
    roleName: allData?.roleName,
    roleTypeId: '',
  });
  const inputChange = (name) => {
    return (event) => {
      setInputValues({ ...inputValues, [name]: event.target.value });
    };
  };

  // button
  const confirmHandle = () => {
    if (typeof confirmClick === 'function') {
      confirmClick(inputValues);
    }
  };

  return (
    <Dialog open={open} maxWidth={false} className={classes.dialog}>
      <div className={classes.root}>
        <div className={classes.header}>
          <Typography className={classes.headerTitle}>{title}</Typography>
          <IconButton id="setting_role_pop_close" className={classes.closeIcon} onClick={closePop}>
            <CloseIcon />
          </IconButton>
        </div>
        <main className={classes.main}>
          <Typography className={classes.label}>{i18n.t('SETTING_ROLE_NAME')}</Typography>
          <InputBase
            id="setting_role_pop_rolename"
            className={classes.InputBase}
            placeholder={i18n.t('SETTING_ROLE_NAME')}
            onChange={inputChange('roleName')}
          />
          <Typography className={classes.label}>{i18n.t('SETTING_ROLE_TYPE')}</Typography>
          <InputBase
            id="setting_role_pop_roletypeid"
            className={classes.InputBase}
            placeholder={i18n.t('SETTING_ROLE_TYPE')}
            onChange={inputChange('roleTypeId')}
          />
        </main>
        <Box display="flex" justifyContent="center" style={{ margin: '1.25rem 0 1.875rem 0' }}>
          <ButtonBase
            id="setting_role_pop_cancel"
            className={classes.cancelBtn}
            style={{ marginRight: '1.313rem' }}
            onClick={closePop}
          >
            {i18n.t('SETTING_CANCEL')}
          </ButtonBase>
          <ButtonBase id="setting_role_pop_confiem" className={classes.configBtn} onClick={confirmHandle}>
            {confirmText}
          </ButtonBase>
        </Box>
      </div>
    </Dialog>
  );
}
